import { defineComponent as _defineComponent } from 'vue'
import SearchableClientList from '@/app/components/clients/SearchableClientList.vue';
import ClientListFilters from '@/app/components/clients/ClientListFilters.vue';
import { AuthorityType, Client } from 'ah-api-gateways';
import SortSelector from 'ah-common-lib/src/common/components/SortSelector.vue';
import { clientTableFields } from '@/app/components/clients/tableFields/clientTableFields';
import { useAuthStore } from '@/app/store/authModule';
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityClientsView',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();

const fields = computed(() => clientTableFields);
const baseUrl = '/admin/activity/clients';

function onClientSelect(client: Client) {
  router.push({ path: `${baseUrl}/${client.id}` });
}

const canExport = computed(() => authStore.hasAuthorities(AuthorityType.EXPORT_CLIENT_REPORTS));

return { __sfc: true,authStore, router, fields, baseUrl, onClientSelect, canExport, SearchableClientList, ClientListFilters, SortSelector }
}

})